// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import VastuLayout from './components/VastuLayout';
import Editor from './pages/pannel/editor/Editor';
import ProjectsPage from './pages/pannel/projects/ProjectsPage';
import AdminLogin from './admin/AdminLogin';
import UserLogin from './pages/auth/UserLogin';
import UserManagement from './admin/UserManagement';
import ForgotPassword from './pages/auth/ForgotPassword';
import ChangePassword from './pages/user/ChangePassword';
import ProfileUpdate from './pages/user/ProfileUpdate';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<UserLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Protected Routes - Main Application */}
          <Route path="/" element={
            <ProtectedRoute>
              <VastuLayout />
            </ProtectedRoute>
          }>
            <Route index element={<ProjectsPage />} />
            <Route path="projects" element={<ProjectsPage />} />

            <Route path="editor" element={<Editor />} />
            <Route path="editor/new" element={<Editor />} />
            <Route path="editor/:projectId" element={<Editor />} />

            {/* User Settings */}
            <Route path="settings/change-password" element={<ChangePassword />} />
            <Route path="settings/profile" element={<ProfileUpdate />} />

            {/* Admin Only Routes */}
            <Route path="admin/users" element={
              <ProtectedRoute adminOnly={true}>
                <UserManagement />
              </ProtectedRoute>
            } />
          </Route>

          <Route path="/pannel" element={
            <ProtectedRoute>
              <VastuLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/" replace />} />
            <Route path="editor" element={<Navigate to="/" replace />} />
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
